import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { ImageInfo } from "./imageSlice";
import { getToken } from "../../features/user/UserAvatar";
import { ObjectTarget } from "../../app/permissions";

export interface ImageSetAvatarState {
  state: LoadStateInfo;
}

const initialState: ImageSetAvatarState = {
  state: notStarted(),
};

export interface ImageSetAvatarRequest {
  imageId: string;
  objectTarget: ObjectTarget;
  targetId: string;
}

export const imageSetAvatarThunk = createAsyncThunk(
  "imageSetAvatar",
  async (param: ImageSetAvatarRequest, thunkAPI) => {
    console.debug("image set avatar");

    const response = await fetch(`${getBackendUrl()}/api/image/${param.imageId}/avatar/${param.objectTarget}/${param.targetId}`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });

    if(response.ok) {
      return response.text();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const imageSetAvatarSlice = createSlice({
  name: "imageSetAvatarSlice",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    set: (state, action: PayloadAction<ImageInfo>) => {
      state.state = notStarted();
    },
    clean: (state) => {
      state.state = notStarted();
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(imageSetAvatarThunk.pending, (state, action) => {
        state.state =  loading();
      })
      .addCase(imageSetAvatarThunk.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
      })
      .addCase(imageSetAvatarThunk.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

export const { } = imageSetAvatarSlice.actions;

export const selectImageSetAvatar = (state: RootState) => state.imageSetAvatar;

export default imageSetAvatarSlice.reducer;
